import axios from "axios";
const lagn = localStorage.getItem("lang");
export const baseURL = "https://api.stars-ai.com";

// task plan URL's
// export const baseURL = "https://stars.tasksplan.com:4001";
// export const baseURL = "https://stars.tasksplan.com:4000";
// export const baseURL = "http://192.168.29.51:4000";

// export const baseURL = "https://stars.tasksplan.com:5000";
// export const baseURL = "http://192.168.1.42:4000";
// export const baseURL = "http://192.168.1.42:4000";
const axiosInstacnce = axios.create({
  baseURL: baseURL + "/star-backend/api",
});

// export const APPURL = baseURL == "https://stars-ai.com/api" ? "/teacher" : "";
axiosInstacnce.defaults.headers.common["Accept-Language"] = lagn ? lagn : "en";
export default axiosInstacnce;
